import { getReactInstrumentation } from './core/instrumentation/sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { CurrentLocale } from './core/locale';
import { LanguageProvider } from './LanguageProvider';
import EnrollKlarnaView from './views/EnrollKlarnaView';
import WidgetButtonView from './views/WidgetButtonView';
import Main from './components/Main/Main';
import { AppContextProvider } from './core/context';
import { PlatformProvider } from './platform';
import { FeatureFlagsProvider } from './feature-flags';
import { installGlobalErrorHandlers } from './core/services/globalErrorHandlers';

installGlobalErrorHandlers();

const container = document.getElementById('root');
if (!container) {
  throw new Error('app root element not found');
}

const root = createRoot(container, getReactInstrumentation());
const pathname = window.location.pathname.toLowerCase();
const app =
  pathname.includes('/enrollklarna') ?
    // TODO: change this when we rethink the router approach
    <PlatformProvider>
      <FeatureFlagsProvider>
        <Main showCancelLink={false}>
          <EnrollKlarnaView />
        </Main>
      </FeatureFlagsProvider>
    </PlatformProvider>
  : pathname.includes('/widget-button') ?
    // Minimal button page embedded by the widget SDK (renders only the button).
    <WidgetButtonView />
  : <App />;

if (root) {
  root.render(
    <React.StrictMode>
      <AppContextProvider>
        <LanguageProvider>{app}</LanguageProvider>
      </AppContextProvider>
    </React.StrictMode>
  );
}

document.getElementsByTagName('html')?.item(0)?.setAttribute('lang', CurrentLocale.split('-')[0]);
